"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENSControllerContract = void 0;
const contracts_1 = require("@etherspot/contracts");
const internal_contract_1 = require("./internal.contract");
class ENSControllerContract extends internal_contract_1.InternalContract {
    constructor() {
        super(contracts_1.ContractNames.ENSController);
    }
    encodeSetAddr(...args) {
        let result = null;
        switch (args.length) {
            case 2:
                result = this['encodeSetAddr(bytes32,address)'](args[0], args[1]);
                break;
            case 3:
                result = this['encodeSetAddr(bytes32,uint256,bytes)'](args[0], args[1], args[2]);
                break;
        }
        return result;
    }
}
exports.ENSControllerContract = ENSControllerContract;
